import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3e6039c0&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=3e6039c0&prod&scoped=true&lang=css"
import style1 from "./Footer.vue?vue&type=style&index=1&id=3e6039c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6039c0",
  null
  
)

export default component.exports